document.addEventListener('DOMContentLoaded', () => {
  class YGAccordion extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const header = this.querySelector('.yg-accordion-header');
      const content = this.querySelector('.yg-accordion-content');
      header.addEventListener('click', () => {
        const trueHeight = content.scrollHeight;
        content.style.setProperty('--true-height', `${trueHeight}px`);
        this.classList.toggle('yg-accordion-open');
      });
    }
  }

  if (!window.customElements.get('yg-accordion')) {
    window.customElements.define('yg-accordion', YGAccordion);
  }

  const closeAllQuantityDropdowns = () => {
    document
      .querySelectorAll('[data-quantity-dropdown]')
      .forEach((dropdown) => {
        dropdown.classList.remove('is-open');
        const trigger = dropdown.querySelector('.yg-quantity-trigger');
        if (trigger) {
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
  };

  document.querySelectorAll('[data-quantity-dropdown]').forEach((dropdown) => {
    const trigger = dropdown.querySelector('.yg-quantity-trigger');
    const valueEl = dropdown.querySelector('.yg-quantity-value');
    const input = dropdown.querySelector('.yg-quantity-input');
    const options = dropdown.querySelectorAll('.yg-quantity-option');

    if (!trigger || !valueEl || !input || options.length === 0) return;

    trigger.addEventListener('click', (event) => {
      event.stopPropagation();
      const isOpen = dropdown.classList.contains('is-open');
      closeAllQuantityDropdowns();
      if (!isOpen) {
        dropdown.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });

    options.forEach((option) => {
      option.addEventListener('click', () => {
        const quantity = option.dataset.quantityValue;
        if (!quantity) return;

        input.value = quantity;
        valueEl.textContent = quantity;

        options.forEach((item) => {
          item.classList.remove('is-selected');
          item.setAttribute('aria-selected', 'false');
        });

        option.classList.add('is-selected');
        option.setAttribute('aria-selected', 'true');

        dropdown.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      });
    });
  });

  document.addEventListener('click', () => {
    closeAllQuantityDropdowns();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeAllQuantityDropdowns();
    }
  });
});
